import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListServices from './ListServices'
import ShowServicePage from './ShowServicePage'
import NewServicePage from './NewServicePage'
import EditServicePage from './EditServicePage'

const Services = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListServices} />
    <Route exact path={match.url + '/new'} component={NewServicePage} />
    <Route path={match.url + '/:id/edit'} component={EditServicePage} />
    <Route path={match.url + '/:id'} component={ShowServicePage} />
  </Switch>
)

export default Services



// WEBPACK FOOTER //
// ./src/components/Services/Services.jsx